import { DocumentStatus } from './types';
import { PERMISSION } from '../../../components/investigation/share/user_roles';

/** Only DRAFT documents can be edited in billing workflows (SHER-423). */
export function isBillEditable(status: DocumentStatus): boolean {
    return status === DocumentStatus.DRAFT;
}

export function isBillCancelled(status: DocumentStatus): boolean {
    return status === DocumentStatus.CANCELLED;
}

/**
 * The "+" (new bill) button opens the create form on an invoice, which the API only accepts
 * with CREATE_BILLING_INVOICE (SHER-888). Gating on the legacy client-only CREATE_BILLING hid
 * the button from roles the API lets create invoices, e.g. MEDICAL_DIRECTOR (SHER-1143).
 */
export function canCreateBillsByHand(permissions: string[] | undefined): boolean {
    return Boolean(permissions && permissions.includes(PERMISSION.CREATE_BILLING_INVOICE));
}
